const styles = {
    listItemView: {
        background: 'transparent',
        height: 50,
        padding: '0',
        cursor: 'default'
    },
    pdoflistItemView: {
        background: 'transparent',
        height: 100,
        padding: '0',
        cursor: 'default',
        textAlign: 'center'
    },
    listItemViewParagraph: {
        margin: 0,
        padding: 10
    },
    listItemViewParagraphWithLink: {
        margin: 0,
        padding: 0,
        paddingLeft: 10,
        position: 'relative',
        top: -10
    },
    pdoflistItemViewParagraph: {
        height: 100,
        margin: 0,
        padding: 10
    },
    pinContainer:{
        width: 400,
        borderRadius: 4,
        background: 'transparent'
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/components/maps/styles/MapComponentStyles.js